import './Feedback.css';

/**
 * Corner spinner shown while a manual save is in flight.
 *
 * Kept mounted and toggled via a class so it fades in/out instead of popping,
 * which matters for the common case where a save finishes in a few hundred ms.
 *
 * @param {boolean} active  true while the save request is running.
 * @param {string}  label   e.g. t('common.saving').
 */
function SavingIndicator({ active = false, label = '' }) {
    return (
        <div
            className={`mc-saving${active ? ' show' : ''}`}
            role="status"
            aria-live="polite"
            aria-hidden={!active}
        >
            <span className="mc-saving-spinner" aria-hidden="true" />
            <span className="mc-saving-label">{label}</span>
        </div>
    );
}

export default SavingIndicator;
